import React from 'react';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { Tooltip } from '@mui/material';
import {
    DeleteIcon,
    DuplicateIcon,
} from '../../svg/UtilsIcons';

export const TemplateDeleteGridAction = ({ label, onClick }) => (
    <GridActionsCellItem
        icon={<Tooltip title={label}><DeleteIcon /></Tooltip>}
        showInMenu
        label={label}
        onClick={onClick}
    />
);

export const TemplateDuplicateGridAction = ({ label, onClick }) => (
    <GridActionsCellItem
        icon={<Tooltip title={label}><DuplicateIcon /></Tooltip>}
        showInMenu
        label={label}
        onClick={onClick}
    />
);

export const buildTemplateSelectedRowActions = ({
    canDeleteTemplate,
    deleteLabel,
    onDelete,
}) => [
    canDeleteTemplate
        ? {
            title: deleteLabel,
            color: 'rgb(236, 69, 78)',
            icon: <DeleteIcon color={'rgb(236, 69, 78)'} />,
            action: (ids) => {
                onDelete(ids);
            },
        }
        : null,
];
